/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Wallet_AnswerInputs */

const en_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You fund one USD wallet and each call draws it down. Some failed wallet-funded requests incur processing charges that we pass through at cost, with no markup; the error response shows the amount charged.`)
};

const zh_hans1_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你只需为一个美元钱包充值，每次调用从中扣费。部分由钱包付费的失败请求会产生处理费用，我们按成本原价转嫁，不加价；错误响应会显示收取的金额。`)
};

const pt_br2_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você recarrega uma carteira em dólares e cada chamada desconta dela. Algumas requisições pagas pela carteira que falham geram cobranças de processamento, que repassamos pelo custo, sem margem; a resposta de erro mostra o valor cobrado.`)
};

const es_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregas fondos a una billetera en dólares y cada llamada descuenta de ella. Algunas solicitudes fallidas pagadas con la billetera generan cargos de procesamiento que trasladamos al costo, sin margen; la respuesta de error muestra el monto cobrado.`)
};

const fr_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous alimentez un portefeuille en USD et chaque appel le débite. Certaines requêtes échouées financées par le portefeuille entraînent des frais de traitement que nous répercutons au prix coûtant, sans marge ; la réponse d’erreur indique le montant facturé.`)
};

const de_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du lädst ein USD-Guthabenkonto auf, und jeder Aufruf bucht davon ab. Bei manchen fehlgeschlagenen, vom Guthabenkonto bezahlten Anfragen fallen Bearbeitungsgebühren an, die wir zum Selbstkostenpreis ohne Aufschlag weitergeben. Die Fehlerantwort zeigt den berechneten Betrag.`)
};

const ru_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы пополняете один кошелёк в долларах США, и каждый вызов списывает с него. По некоторым неудавшимся запросам, оплаченным из кошелька, возникают расходы на обработку; мы передаём их по себестоимости, без наценки, а сумма списания указана в ответе с ошибкой.`)
};

const it_seo_wallet_answer = /** @type {(inputs: Seo_Wallet_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarichi un portafoglio in USD e ogni chiamata lo scala. Alcune richieste fallite finanziate dal portafoglio comportano costi di elaborazione che trasferiamo al costo, senza ricarico; la risposta di errore mostra l'importo addebitato.`)
};

/**
* | output |
* | --- |
* | "You fund one USD wallet and each call draws it down. Some failed wallet-funded requests incur processing charges that we pass through at cost, with no markup..." |
*
* @param {Seo_Wallet_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_wallet_answer = /** @type {((inputs?: Seo_Wallet_AnswerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Wallet_AnswerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_wallet_answer(inputs)
	if (locale === "pt-BR") return pt_br2_seo_wallet_answer(inputs)
	if (locale === "es") return es_seo_wallet_answer(inputs)
	if (locale === "fr") return fr_seo_wallet_answer(inputs)
	if (locale === "de") return de_seo_wallet_answer(inputs)
	if (locale === "ru") return ru_seo_wallet_answer(inputs)
	if (locale === "it") return it_seo_wallet_answer(inputs)
	return en_seo_wallet_answer(inputs)
});